import { put, fork } from 'redux-saga/effects'
import { takeLatestAndCancel } from './take'
import makeItemsSaga from './makeItems'
import { authApiCall } from './helpers'

import {
  GET_OTHER_USER_WANTED_ITEMS,
  GET_OTHER_USER_OWNED_ITEMS,
  GET_OTHER_USER_ITEMS_I_CAN_GET,
  GET_OTHER_USER_ITEMS_I_CAN_GIVE,
  GET_OTHER_USER_INFO,
  GET_OTHER_USER_INFO_LOADING,
  GET_OTHER_USER_INFO_FAILURE,
  GET_OTHER_USER_INFO_SUCCESS,
  GET_OTHER_USER_INFO_UNLOAD,
  GET_OTHER_USER_COUNTS,
  GET_OTHER_USER_COUNTS_LOADING,
  GET_OTHER_USER_COUNTS_FAILURE,
  GET_OTHER_USER_COUNTS_SUCCESS,
} from '../actions'

import * as api from '../api'

function* handleGetUserInfo({ payload }) {
  const userIdOrUsername = payload
  yield put({ type: GET_OTHER_USER_INFO_LOADING })
  try {
    const ohterUserInfo = yield authApiCall(api.getUserInfo, userIdOrUsername)
    yield put({ type: GET_OTHER_USER_INFO_SUCCESS, payload: ohterUserInfo })
  } catch (error) {
    yield put({ type: GET_OTHER_USER_INFO_FAILURE, error })
  }
}

function* handleGetUserCounts({ payload }) {
  const userId = payload
  yield put({ type: GET_OTHER_USER_COUNTS_LOADING })
  try {
    const [ownedItems, wantedItems, itemsICanGet] = [
      yield authApiCall(api.countOwnedItemsOfUser, userId),
      yield authApiCall(api.countWantedItemsOfUser, userId),
      yield authApiCall(api.countItemsICanGetFromOtherUser, userId),
    ]
    yield put({
      type: GET_OTHER_USER_COUNTS_SUCCESS,
      payload: {
        ownedItems,
        wantedItems,
        itemsICanGet,
      },
    })
  } catch (error) {
    yield put({ type: GET_OTHER_USER_COUNTS_FAILURE, error })
  }
}

// Saga of other user
export default function* otherUser() {
  // Other user
  yield fork(
    takeLatestAndCancel,
    GET_OTHER_USER_INFO,
    GET_OTHER_USER_INFO_UNLOAD,
    handleGetUserInfo
  )
  yield fork(
    takeLatestAndCancel,
    GET_OTHER_USER_COUNTS,
    GET_OTHER_USER_INFO_UNLOAD,
    handleGetUserCounts
  )
  yield fork(
    makeItemsSaga(
      GET_OTHER_USER_WANTED_ITEMS,
      api.getWantedItems,
      state => state.otherUser.wantedItems
    )
  )
  yield fork(
    makeItemsSaga(
      GET_OTHER_USER_OWNED_ITEMS,
      api.getOwnedItems,
      state => state.otherUser.ownedItems
    )
  )
  yield fork(
    makeItemsSaga(
      GET_OTHER_USER_ITEMS_I_CAN_GET,
      api.getItemsICanGet,
      state => state.otherUser.itemsICanGet
    )
  )
  yield fork(
    makeItemsSaga(
      GET_OTHER_USER_ITEMS_I_CAN_GIVE,
      api.getItemsICanGive,
      state => state.otherUser.itemsICanGive
    )
  )
}



// WEBPACK FOOTER //
// ./src/saga/otherUser.js